import { render, staticRenderFns } from "./form-video-script.vue?vue&type=template&id=6a01fe49&"
import script from "./form-video-script.vue?vue&type=script&lang=js&"
export * from "./form-video-script.vue?vue&type=script&lang=js&"
import style0 from "./form-video-script.vue?vue&type=style&index=0&id=6a01fe49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports